import { createApi } from "@reduxjs/toolkit/query/react";

import { BASE_URL, GET_MANAGE_GROUPS } from "../constants";
import customBaseQuery from "../CustomBaseQuery/customBaseQuery";

export const manageGroups = createApi({
  reducerPath: "manageGroups",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchGroupsTableData: builder.query({
      query: ({ token, pagination, orggrp_id }) => {
        const params = new URLSearchParams({
          ...pagination,
        });

        const url = `${GET_MANAGE_GROUPS}${pagination.toString()}&orggrp_id=${orggrp_id}`;
        return {
          url,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
  }),
});

export const { useFetchGroupsTableDataQuery } = manageGroups;
